import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Lock, CreditCard } from 'lucide-react';
export function PricingSection() {
  return <section className="py-14 md:py-24 px-6 bg-cream relative" data-id="element-123">
      <div className="max-w-3xl mx-auto text-center" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white p-6 md:p-12 rounded-3xl shadow-2xl border border-gold/20" data-id="element-125">
          <p className="text-lg md:text-xl text-charcoal/80 mb-6 md:mb-8 leading-relaxed" data-id="element-126">
            Normalmente, este conocimiento se vende en consultorios privados por
            más de $200. Pero hoy, como parte de nuestro lanzamiento mundial
            para democratizar la salud de la piel...
          </p>

          <h3 className="text-2xl font-bold mb-4 md:mb-6" data-id="element-127">
            Puedes llevarte el sistema completo por solo:
          </h3>

          <div className="text-6xl md:text-8xl font-bold text-gold font-serif mb-4 md:mb-6 drop-shadow-sm" data-id="element-128">
            $11<span className="text-2xl md:text-4xl" data-id="element-129">.99 USD</span>
          </div>

          <p className="text-charcoal/60 mb-6 md:mb-10 font-medium" data-id="element-130">
            (Un solo pago. Acceso de por vida. Menos de lo que cuesta un café y
            un postre).
          </p>

          <CTAButton className="w-full md:w-auto text-lg py-5 px-10 mb-6" onClick={() => window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        })} data-id="element-131">
            SÍ, QUIERO MI PIEL DE PORCELANA
          </CTAButton>

          <div className="flex items-center justify-center gap-4 text-sm text-charcoal/50 mt-6" data-id="element-132">
            <div className="flex items-center gap-1" data-id="element-133">
              <Lock className="w-4 h-4" data-id="element-134" /> Pago Seguro
            </div>
            <div className="flex items-center gap-1" data-id="element-135">
              <CreditCard className="w-4 h-4" data-id="element-136" /> Acceso Inmediato
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}